
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[categoryPath]",
      function () {
        return require("private-next-pages/category/[categoryPath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/[categoryPath]"])
      });
    }
  